import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { IonicModule } from "@ionic/angular";

import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { GamesService } from "src/app/services/lobby/games.service";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { Navigator } from "../../menu/navigator";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Subscription } from "rxjs";
import { JackpotCounterModule } from "../../jackpot-notification/jackpot-counter.module";

@Component({
    selector: 'app-game-tile',
    templateUrl: "./game-tile.component.html",
    styleUrls: ["./game-tile.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        CommonModule,
        JackpotCounterModule
    ]
})

export class GameTileComponent implements OnInit {
    @Input() gameData: any;

    public imagesPath: string;
    public imageName: string;
    public isAuthenticated: boolean;
    private authSubscription: Subscription;

    constructor(
        private readonly gamesService: GamesService,
        private readonly gameHubControllerService: GameHubControllerService,
        private readonly lobbyService: LobbyService,
        private readonly navigator: Navigator,
        private readonly userSessionService: UserSessionService,
    ) {
    }

    ngOnInit(): void {
        this.imagesPath = this.lobbyService?.galleryImagePath;
        this.imageName = this.gameData?.imagename;

        this.updateAuthentication();
       /* this.userSessionService
            .getCustomerSubscription()
            .then((subscription) => this.subscribeToCustomer(subscription));
        this.updateAuthentication();*/
    }

    subscribeToCustomer(subscription) {
        subscription.subscribe(() => {
            this.updateAuthentication();

        });
    }

    updateAuthentication() {
    // Subscribe to the authentication status observable
    this.authSubscription = this.userSessionService.getCustomer().subscribe((customer) => {
      this.isAuthenticated = !!customer;
    });
    }

   /* updateAuthentication() {
        this.userSessionService.isAuthenticated().then((isAuthenticated) => {
            this.isAuthenticated = isAuthenticated;
        });
    }*/

    launchCasinoGame(gameData) {
        if (!this.isAuthenticated) {
            return this.openLoginModal(gameData);
        }

        return this.gameHubControllerService.launchCasinoGame(gameData);
    }

     launchDemoPlay(gameData) {
        if(this.isAuthenticated) {
            return this.gameHubControllerService.launchCasinoGameDemo(gameData);
        }
        this.navigator.toAgeVerificationModal(gameData);
    }

    openLoginModal(gameData) {
        this.lobbyService.setWaitingGameData(gameData);
        return this.navigator.navigateTo("LoginComponent");
    }

    public onInfo(gamedata: any) {
        return this.navigator.navigateTo('GameDetailsComponent', { multipleModals: false }, { gamedata });
    }

    makeFavourite(gamedata, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (!this.isAuthenticated) {
            this.navigator.navigateTo("LoginComponent");
            return;
        }

        this.gamesService.addFavouritesAndRecreate(gamedata);
        return;
    }

    makeUnFavourite(game_id, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (!this.isAuthenticated) {
            this.navigator.navigateTo("LoginComponent");
            return;
        }

        this.gamesService.removeFavouritesAndRecreate(game_id);

        return;
    }

    isFavourite(game_id) {
        if (!this.isAuthenticated) return false;
        return this.gamesService.isFavourite(game_id);
    }
}
